import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const VideoPreview = ({ viewUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Card sx={{ maxWidth: 600, position: "relative" }}>
      {!isPlaying ? (
        <>
          <CardMedia
            component="video"
            src={viewUrl}
            onClick={() => setIsPlaying(true)}
            sx={{
              cursor: "pointer",
              filter: "brightness(0.7)",
              height: 340,
              objectFit: "cover",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
            }}
          >
            <IconButton
              onClick={() => setIsPlaying(true)}
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.7)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.9)" },
                width: 64,
                height: 64,
              }}
            >
              <PlayArrowIcon sx={{ fontSize: 40 }} />
            </IconButton>
          </Box>
        </>
      ) : (
        <CardMedia
          component="video"
          src={viewUrl}
          autoPlay
          controls
          sx={{ height: 340 }}
        />
      )}
    </Card>
  );
};

export default VideoPreview;
